/* eslint-disable */
import { BehaviorSubject, Subject } from "rxjs";
import { get, del, put, post } from "../../../http";
import { isAuth, getToken } from "../../../auth/shared/utils/auth";
import { userService } from "../../../user";

export type Department = {
  id?: number;
  name: string;
  isDeleted: boolean;
};

export enum DepartmentError {
  Network,
  Server,
  InvalidCredentials,
  DuplicateEmail,
}

export class DepartmentService {
  private _baseUrl: string;
  private _departments$ = new BehaviorSubject<Department[]>([]);
  private _error$ = new Subject<DepartmentError | null>();
  private _loading$ = new BehaviorSubject<boolean>(false);

  public get error$() {
    return this._error$.asObservable();
  }

  public get departments$() {
    return this._departments$.asObservable();
  }

  public get departments() {
    return this._departments$.value;
  }

  public get loading$() {
    return this._loading$.asObservable();
  }

  public get loading() {
    return this._loading$.value;
  }

  constructor(apiUrl: string) {
    this._baseUrl = apiUrl + "/departments";
  }

  // TODO Вынести в глобальный метод добавление заголовка
  addAuthInHeadersOption = () => {
    let options = {};
    if (isAuth()) {
      const token = getToken();
      options = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
    }
    return options;
  };

  async getDepartmentsList(paramSort?: number) {
    try {
      this._loading$.next(true);

      const options = this.addAuthInHeadersOption();
      const result = await get(`${this._baseUrl}`, paramSort ? { sort: paramSort } : undefined, options);
      result.json().then((res) => {
        this._departments$.next(res);
      });

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);

      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("get users list fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
  }

  async createDepartment(userInfo: Department) {
    try {
      this._loading$.next(true);
       
      const options = this.addAuthInHeadersOption();
      const result = await post(`${this._baseUrl}`, userInfo, options);
      return result.json().then((res) => {
        if (res && res.status === 409) {
          this._error$.next(DepartmentError.DuplicateEmail);
          return false;
        } else if (res.length > 0 && res[0].code === "DuplicateUserName") {
          this._error$.next(DepartmentError.DuplicateEmail);
          return false;
        } else {
          this._departments$.next([...this.departments, res]);
        }
        this._loading$.next(false);
        return true;
      });
    } catch (err) {
      this._loading$.next(false);

      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("create user fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
  }

  async updateDepartment(userInfo: Department) {
    try {
      this._loading$.next(true);

      const options = this.addAuthInHeadersOption();
      await put(`${this._baseUrl}/${userInfo.id}`, userInfo, options);
      this.updateDataDepartment(userInfo, userInfo.id!);
      await userService.getUserInfo();

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);

      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("udpate user fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
  }

  async deleteDepartment(userId: number) {
    try {
      this._loading$.next(true);

      const options = this.addAuthInHeadersOption();
      await del(`${this._baseUrl}/${userId}`, options);
      this.updateDeletedDepartment(userId);

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);

      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("delete user fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
  }

  updateDataDepartment = (userInfo: Department, userId: number) => {
    const userIndex = this.departments.findIndex((u) => u.id === userId);
    const emptyFindIndex = -1;
    if (userIndex !== emptyFindIndex) {
      const users = [...this.departments];
      users[userIndex] = {
        ...users[userIndex],
        ...userInfo,
      };
      this._departments$.next(users);
    }
  };

  updateDeletedDepartment = (userId: number) => {
    const userIndex = this.departments.findIndex((u) => u.id === userId);
    const emptyFindIndex = -1;
    if (userIndex !== emptyFindIndex) {
      const deleteCount = 1;
      const users = [...this.departments];
      users.splice(userIndex, deleteCount);
      this._departments$.next(users);
    }
  };
}
